import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { addLogistics } from "../services/btc-api.service";

export default function Logistics() {
    const user = useSelector((state) => state.user.user);
    const [selectedCountryCode, setSelectedCountryCode] = useState("+1");
    const [portValue, setPortValue] = useState("");
    const [countryValue, setCountryValue] = useState("");
    const [vehicleNameValue, setVehicleNameValue] = useState("");
    const [name, setName] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [shippingMethodValue, setShippingMethodValue] = useState("");
    const [selectedOptionValue, setSelectedOptionValue] = useState("");

    const countryCodes = [
        {
            name: "Canada",
            dial_code: "+1",
            code: "CA",
        },
        {
            name: "Cayman Islands",
            dial_code: "+345",
            code: "KY",
        },
        {
            name: "China",
            dial_code: "+86",
            code: "CN",
        },
        {
            name: "Afghanistan",
            dial_code: "+93",
            code: "AF",
        },
        {
            name: "Aland Islands",
            dial_code: "+358",
            code: "AX",
        },
        {
            name: "Denmark",
            dial_code: "+45",
            code: "DK",
        },
        {
            name: "Hong Kong",
            dial_code: "+852",
            code: "HK",
        },
        {
            name: "Iceland",
            dial_code: "+354",
            code: "IS",
        },
        {
            name: "India",
            dial_code: "+91",
            code: "IN",
        },
        {
            name: "Indonesia",
            dial_code: "+62",
            code: "ID",
        },
        {
            name: "Ireland",
            dial_code: "+353",
            code: "IE",
        },
        {
            name: "Italy",
            dial_code: "+39",
            code: "IT",
        },
        {
            name: "Japan",
            dial_code: "+81",
            code: "JP",
        },
        {
            name: "Kuwait",
            dial_code: "+965",
            code: "KW",
        },
        {
            name: "Mexico",
            dial_code: "+52",
            code: "MX",
        },
        {
            name: "Norway",
            dial_code: "+47",
            code: "NO",
        },
        {
            name: "Oman",
            dial_code: "+968",
            code: "OM",
        },
        {
            name: "Pakistan",
            dial_code: "+92",
            code: "PK",
        },
        {
            name: "Poland",
            dial_code: "+48",
            code: "PL",
        },
        {
            name: "Portugal",
            dial_code: "+351",
            code: "PT",
        },
        {
            name: "Romania",
            dial_code: "+40",
            code: "RO",
        },
        {
            name: "Russia",
            dial_code: "+7",
            code: "RU",
        },
    ];

    useEffect(() => {
        if (user) {
            setCountryValue(user.port);
            setContactNumber(user.contactNumber);
            setName(`${user.firstName} ${user.lastName} `);
            setEmailValue(user.email);
            setShippingMethodValue(user.shippingMethod);
        }
    }, [user]);

    const handleShippingMethodChange = (event) => {
        const { value } = event.target;
        setShippingMethodValue(value);
    };

    const handleCountryCodeChange = (e) => {
        setSelectedCountryCode(e.target.value);
    };

    const handleSelectedOptionChange = (event) => {
        const { value } = event.target;
        setSelectedOptionValue(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let body = null;

        if (user && user._id) {
            body = {
                userId: user._id,
                from: portValue,
                vehicleName: vehicleNameValue,
                vehicleCondition: selectedOptionValue
            }
        } else {
            body = {
                name: name,
                email: emailValue,
                contactNumber: contactNumber,
                countryCode: selectedCountryCode,
                selectedOption: shippingMethodValue,
                from: portValue,
                to: countryValue,
                vehicleName: vehicleNameValue,
                vehicleCondition: selectedOptionValue
            }
        }


        await addLogistics(body);

    }

    return (
        <div className="logistics-page">
            <form onSubmit={handleSubmit} >
                <div className="container">
                    <img src="logistics logo.png" alt="Logo" />
                    <div className="row justify-content-center inputpadding-logistics">
                        <div className="col-12 col-md-5 col-lg-6 ">
                            <input
                                value={portValue}
                                onChange={(e) => setPortValue(e.target.value)}
                                required
                                type="text"
                                placeholder="From Port"
                                className="border border-secondary rounded mb-2 form-control"
                            />
                        </div>
                        <div className="col-12 col-md-5 col-lg-6">
                            <input
                                value={countryValue}
                                onChange={(e) => setCountryValue(e.target.value)}
                                disabled={
                                    user && user.port !== undefined && user.port !== ""
                                }
                                required
                                type="text"
                                placeholder="To Port"
                                className="border border-secondary rounded form-control"
                            />
                        </div>
                    </div>
                    <div className="row justify-content-center inputpadding-logistics">
                        <div className="col-12 col-md-5 col-lg-6">
                            <input
                                type="text"
                                required
                                value={vehicleNameValue}
                                onChange={(e) => setVehicleNameValue(e.target.value)}
                                placeholder="Vehicle Name"
                                className="border border-secondary rounded form-control"
                            />
                        </div>
                        <div className="col-12 col-md-5 col-lg-6 d-flex justify-content-center p-2">
                            <label htmlFor="Drivable">
                                <input
                                    required
                                    type="radio"
                                    value={"Drivable"}
                                    name="quality1"
                                    id="Drivable"
                                    onChange={handleSelectedOptionChange}
                                    className="radio-small "
                                />{" "}
                                <span className="small-text-2">Drivable</span>
                            </label>
                            <div className="mx-3"></div>
                            <label htmlFor="Non Drivable">
                                <input
                                    type="radio"
                                    value={"Non Drivable"}
                                    name="quality1"
                                    id="Non Drivable"
                                    onChange={handleSelectedOptionChange}
                                    className="radio-small"
                                />{" "}
                                <span className="small-text-2">Non Drivable</span>
                            </label>
                        </div>
                    </div>
                    <div className="row justify-content-center inputpadding-logistics">
                        <div className="col-12 col-md-5 col-lg-6 ">
                            <input
                                required
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                disabled={
                                    user && user.firstName !== undefined && user.firstName !== ""
                                }
                                placeholder="Your Name"
                                className="border border-secondary rounded form-control"
                            />
                        </div>
                        <div className="col-3 col-md-1 col-lg-1 ">
                            <select

                                className="border border-secondary rounded country-code-logistics"
                                value={selectedCountryCode}
                                onChange={handleCountryCodeChange}
                            >
                                {countryCodes.map((country) => (
                                    <option key={country.dial_code} value={country.dial_code}>
                                        {country.dial_code}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-9 col-md-4 col-lg-5">
                            <input
                                required
                                type="text"
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                disabled={
                                    user &&
                                    user.contactNumber !== undefined &&
                                    user.contactNumber !== ""
                                }
                                placeholder="Contact NO."
                                className="border border-secondary rounded form-control"
                            />
                        </div>
                    </div>
                    <div className="row justify-content-center inputpadding-logistics">
                        <div className="col-12 col-md-10 col-lg-12">
                            <input
                                required
                                type="email"
                                value={emailValue}
                                onChange={(e) => setEmailValue(e.target.value)}
                                disabled={user && user.email !== undefined && user.email !== ""}
                                placeholder="Email"
                                className="border border-secondary rounded form-control"
                            />
                        </div>
                    </div>
                    <div className="row justify-content-center inputpadding-logistics">
                        <div className="col-12 col-md-10 col-lg-12 d-flex justify-content-center">
                            <label htmlFor="Container">
                                <input
                                    required
                                    type="radio"
                                    value="container"
                                    // checked={shippingMethodValue === "container"}
                                    onChange={handleShippingMethodChange}
                                    // disabled={
                                    //     user &&
                                    //     user.shippingMethod !== undefined &&
                                    //     user.shippingMethod !== ""
                                    // }
                                    name="quality"
                                    id="Container"
                                    className="radio-default"
                                />{" "}
                                <span className="small-text">Container</span>
                            </label>
                            <div className="mx-3"></div>
                            <label htmlFor="RORO">
                                <input
                                    type="radio"
                                    value="roro"
                                    // checked={shippingMethodValue === "roro"}
                                    onChange={handleShippingMethodChange}
                                    // disabled={
                                    //     user &&
                                    //     user.shippingMethod !== undefined &&
                                    //     user.shippingMethod !== ""
                                    // }
                                    name="quality"
                                    id="RORO"
                                    className="radio-default"
                                />{" "}
                                <span className="small-text">RORO</span>
                            </label>
                        </div>
                    </div>
                    <div className="m-2 d-flex justify-content-center inputpadding-logistics">
                        <div className="col-12 col-md-10 col-lg-12">
                            <button type="submit">Submit Request</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
